import type { Resource, ResourceCost } from '../../types/game-types';
import { useCurrencyStore } from '../zustand/useCurrencyStore';

/**
 * Deducts the given costs from the Zustand currency store.
 * Returns false when any listed resource is insufficient (store unchanged).
 */
export function trySpendResources(purchaseCost: ResourceCost): boolean {
  const currency = useCurrencyStore.getState();
  const resources = Object.keys(purchaseCost) as Resource[];

  for (const resource of resources) {
    const cost = purchaseCost[resource];
    if (cost === undefined) continue;
    const balance = currency[resource];
    if (balance < cost) {
      return false;
    }
  }

  const nextGold = currency.gold - (purchaseCost.gold ?? 0);
  const nextWood = currency.wood - (purchaseCost.wood ?? 0);
  const nextOre = currency.ore - (purchaseCost.ore ?? 0);
  const nextFood = currency.food - (purchaseCost.food ?? 0);

  useCurrencyStore.getState().sync({
    gold: nextGold,
    wood: nextWood,
    ore: nextOre,
    food: nextFood,
  });

  return true;
}
